// extracted by mini-css-extract-plugin
export default {"HeaderInput":"style_HeaderInput__-Fgu6"};